import { render } from "./HeroiconsSolidShieldExclamation.vue?vue&type=template&id=15e6a91b"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShieldExclamation.vue"]])

export default __exports__